import axios from "axios";
import http, { httpLocal } from "./http";
import { resumeToPipeableStream } from "react-dom/server";


class ApiService {

    async getCategories () {
        const result = await http.get('/category');
        return result.data
    }

    async getCountries () {
        const result = await http.get('/countries');
        return result.data
    }

    async getCategory (slug) {
        const result = await http.get(`/category/${slug}/`);
        return result.data
    }

    async getTeachers () {
        const result = await http.get('/teacher');
        return result.data
    }

    async getReviews () {
      const  result = await http.get('/review');
      return result.data
    }

     async getCourses () {
        const result = await http.get('/course');
        return result.data
    }

    async getMyCourses() {
        const result = await http.get('/course/my_courses/');
        return result.data
    }

    async getMyCourse(slug) {
        const result = await http.get(`/course/my_courses/?course_slug=${slug}`);
        return result.data
    }

   async getMyCourseAdmin(userSlug, orgSlug = null) {
      const result = await http.get("/course/my_courses/", {
        params: {
          user_slug: userSlug,
          ...(orgSlug ? { org_slug: orgSlug } : {})
        }
      });

      return result.data;
    }

    async getMyReview(id) {
        const result = await http.get(`/review/my_review/?course=${id}`);
        return result.data
    }

    async getMyUsers(courseSlug = null) {
      const result = await http.get('/organization/my_users/', {
        params: courseSlug ? { course_slug: courseSlug } : {}
      });

      return result.data;
}

    async getCourseUsers(courseSlug) {
      const result = await http.get(`/organization/course_users/?course=${courseSlug}`);
      return result.data
    }


     async getUsers () {
        const result = await http.get('/userlist');
        return result.data
    }

    async getUser (slug) {
        const result = await http.get(`/userlist/${slug}/`);
        return result.data
    }
    

    async getMyData () {
        const result = await http.get('/userlist/me');
        return result.data
    }

    async getLesson (id) {
        const result = await http.get(`/lesson/${id}/`);
        return result.data
    }

    async updateMyData(data) {
        const result = await http.patch('/userlist/me/', data);
        return result.data;
    }

    async deleteMyAccount() {
        const result = await http.delete('/userlist/me/');
        return result.data;
    }


    async getMyResults() {
      const result = await http.get('/result/');
      return result.data;
    }


    async getModulesByCourse(slug) {
        const result = await http.get(`/module/?course=${slug}`);
        return result.data;
      }

    async getModuleSequential(slug){
      const result = await http.get(`/module/sequential/?course=${slug}`);
      return result.data;
    }

    async getLessonDetail(id){
      const result = await http.get(`/lesson-detail/${id}/`);
      return result.data;
    }

    

    async getTeacher (slug) {
        const result = await http.get(`/teacher/${slug}/`);
        return result.data
    }

    async getCourse (slug) {
        const result = await http.get(`/course/${slug}/`);
        return result.data
    }

    async getCourseReviews(slug) {
      const result = await http.get(`/review/?course=${slug}`);
      return result.data;
      }


    async getModule(slug) {
      const result = await http.get(`/module/${slug}/`);
      return result.data;
    }

   
    async getLessonsByModule(slug) {
      const result = await http.get(`/lesson/?module=${slug}`);
      return result.data;
    }

    
    async getAttachmentsByModule(slug) {
      const result = await http.get(`/attachment/?module_slug=${slug}`);
      return result.data;
    }


    async newCategory (data) {
        const result = await http.post('/category/', data, {
        headers: { 'Content-Type': 'application/json' },
      });
        return result.data
    }

    async getOrganizations () {
        const result = await http.get('/organization');
        return result.data
    }

    async getOrganization(slug) {
      const result = await http.get(`/organization/${slug}/`);
      return result.data;
    }


     async newTeacher (form) {
        const formData = new FormData();
        formData.append('first_name', form.first_name);
        formData.append('last_name', form.last_name);
        formData.append('professional_qualification', form.professional_qualification);
        formData.append('about_me', form.about_me);
    if (form.img_profile) {
      formData.append('img_profile', form.img_profile);
    }
        const result = await http.post('/teacher/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
        return result.data
    }

    async newCourse (form) {
      const formData = new FormData();
      formData.append('title', form.title);
      formData.append('description', form.description);
      formData.append('goals', form.goals);
      formData.append('audience', form.audience);
      formData.append('course_structure', form.course_structure);
      formData.append('access_restrictions', form.access_restrictions);
      formData.append('certificate', form.certificate);
      formData.append('course_program', form.course_program);
      formData.append('highlighted', form.highlighted);
      formData.append('visibility', form.visibility);
      formData.append('my_total_duration', form.my_total_duration);
      if (form.main_img) {
        formData.append('main_img', form.main_img);
      }
      form.teachers.forEach((teacherId) => formData.append('teachers', teacherId));
      formData.append('category', form.category);
     

      const result = await http.post('/course/', formData,{
        headers: { 'Content-Type': 'multipart/form-data' }
      });
        return result.data
    }

    async newOrganization (form) {
      const formData = new FormData();
      formData.append('name', form.name);
      formData.append('email', form.email);
      formData.append('nation', form.nation);
      formData.append('city', form.city);
      formData.append('create_admin', form.create_admin);
      formData.append('admin_first_name', form.admin_first_name);
      formData.append('admin_last_name', form.admin_last_name);
      formData.append('admin_tax_id', form.admin_tax_id);

      const result = await http.post('/organization/', formData,{
        headers: { 'Content-Type': 'multipart/form-data' }
      });
        return result.data
    }

    async createOrganizationCourse(data) {
      const result = await http.post('/organization-course/', data, {
        headers: { 'Content-Type': 'application/json' },
      });
      return result.data;
    }

    async getOrganizationCourses(organizationId) {
      const result = await http.get('/organization-course/', {
        params: {
          organization: organizationId
        }
      });

      return result.data;
    }

    async deleteOrganizationCourse(id) {
      const result = await http.delete(`/organization-course/${id}/`);
      return result.data;
    }

    async newModule(data) {
      const result = await http.post('/module/', data, {
        headers: { 'Content-Type': 'application/json' },
      });
      return result.data;
    }

    
    async newLesson(form) {
      const formData = new FormData();
      formData.append('title', form.title);
      formData.append('text_content', form.text_content || '');
      formData.append('module', form.module);
      formData.append('order', form.order);
      if (form.reading_time != null) formData.append('reading_time', form.reading_time);
      if (form.completed_video != null) formData.append('completed_video', form.completed_video);
      if (form.media_file) { formData.append('media_file', form.media_file);}

      const result = await http.post('/lesson/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return result.data;
    }

    // --- Esami ---
    async newExam(data) {
        const result = await http.post('/exam/', data);
        return result.data;
    }
    async updateExam(id, data) {
        const result = await http.patch(`/exam/${id}/`, data);
        return result.data;
    }

    async deleteExam(id) {
        const result = await http.delete(`/exam/${id}/`);
        return result.data;
    }

    async getExam(slug) {
        const result = await http.get(`/exam/?module=${slug}`);
        console.log(result.data);
        return result.data;
    }

     async getExamById(id) {
        const result = await http.get(`/exam/${id}/`);
        return result.data
    }

    // --- Domande ---
    async newQuestion(data) {
        const result = await http.post('/question/', data);
        return result.data;
    }

    async updateQuestion(id, data) {
        const result = await http.patch(`/question/${id}/`, data);
        return result.data;
    }

    async deleteQuestion(id) {
        const result = await http.delete(`/question/${id}/`);
        return result.data;
    }

    // --- Scelte ---
    async newChoice(data) {
        const result = await http.post('/choice/', data);
        return result.data;
    }

    async updateChoice(id, data) {
        const result = await http.patch(`/choice/${id}/`, data);
        return result.data;
    }

    async deleteChoice(id) {
        const result = await http.delete(`/choice/${id}/`);
        return result.data;
    }

    async updateCategory (slug, data) {
        const result = await http.patch(`/category/${slug}/`, data, {
        headers: { 'Content-Type': 'application/json' },
      });
        return result.data
    }


    async updateTeacher (form, slug) {
        const formData = new FormData();
        formData.append('first_name', form.first_name);
        formData.append('last_name', form.last_name);
        formData.append('professional_qualification', form.professional_qualification);
        formData.append('about_me', form.about_me);
        
          if (form.img_profile instanceof File) {
        formData.append('img_profile', form.img_profile);
      }
        const result = await http.patch(`/teacher/${slug}/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
        return result.data
    }

    async updateCourse (form, slug) {
      const formData = new FormData();
      formData.append('title', form.title);
      formData.append('description', form.description);
      formData.append('goals', form.goals);
      formData.append('audience', form.audience);
      formData.append('course_structure', form.course_structure);
      formData.append('access_restrictions', form.access_restrictions);
      formData.append('certificate', form.certificate);
      formData.append('course_program', form.course_program);
      formData.append('highlighted', form.highlighted);
      formData.append('visibility', form.visibility);
      formData.append('my_total_duration', form.my_total_duration);
      if (form.main_img instanceof File) {
        formData.append('main_img', form.main_img);
      }
      form.teachers.forEach((teacherId) => formData.append('teachers', teacherId));
      formData.append('category', form.category);

      const result = await http.patch(`/course/${slug}/`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
        return result.data
      }

      async  updateOrganization(form, slug) {
        
        const payload = {
          name: form.name,
          email: form.email,
          nation: form.nation,
          city: form.city,
          create_admin: form.create_admin,
          admin_first_name: form.admin_first_name,
          admin_last_name: form.admin_last_name,
          admin_tax_id: form.admin_tax_id,
        };


        const result = await http.patch(`/organization/${slug}/`, payload, {
          headers: { 'Content-Type': 'application/json' }
        });

        return result.data;
      }

      async updateOrganizationCourse(id, data) {
        const result = await http.patch(`/organization-course/${id}/`, data, {
          headers: { 'Content-Type': 'application/json' }
        });

        return result.data;
      }

      
      async updateModule(slug, data) {
        const result = await http.patch(`/module/${slug}/`, data, {
          headers: { 'Content-Type': 'application/json' },
        });
        return result.data;
      }

      async updateUser(slug, data) {
        const result = await http.patch(`/userlist/${slug}/`, data, {
          headers: { 'Content-Type': 'application/json' },
        });
        return result.data;
      }

      async saveLesson(lesson, slug, order) {
        const formData = new FormData();

        formData.append('title', lesson.title);

        if (lesson.loaded || !lesson.id) {
          formData.append(
            'text_content',
            lesson.text_content || ''
          );
        }

        
        formData.append('module', slug);
        formData.append('order', order);
        formData.append('original_order', order);
        formData.append('reading_ok', lesson.reading_ok);

      
        if (lesson.loaded || !lesson.id) {

          if (lesson.media_url) {
            formData.append('completed_video', 0);
          } else if (lesson.completed_video != null) {
            formData.append('completed_video', lesson.completed_video);
          }

        }


        if (lesson.loaded || !lesson.id) {

          if (lesson.media_file instanceof File) {
            formData.append('media_file', lesson.media_file);
            formData.append('media_url', '');
          }

          else if (
            typeof lesson.media_url === 'string' &&
            lesson.media_url.trim() !== ''
          ) {
            formData.append('media_url', lesson.media_url);
            formData.append('media_file', '');
          }

        }


        if (
          (lesson.loaded || !lesson.id) &&
          lesson.h5p_file instanceof File
        ) {
          formData.append('h5p_file', lesson.h5p_file);
        }


        const config = {
          headers: { 'Content-Type': 'multipart/form-data' },
        };

        if (lesson.id) {
          const result = await http.patch(`/lesson/${lesson.id}/`, formData, config);
          return result.data;
        } else {
          const result = await http.post(`/lesson/`, formData, config);
          return result.data;
        }
      }


      async deleteLesson(id) {
        const result = await http.delete(`/lesson/${id}/`);
        return result.data;
      }

      async deleteLessonWithReorder(id) {
        const result = await http.delete(`/lesson/${id}/delete-with-reorder/`);
        return result.data;
      }

      async saveAttachment(att, slug) {
        const formData = new FormData();
        formData.append('module', slug);
        if (att.file) formData.append('file', att.file);

        if (att.id) {
          if (!att.file) return; 
          const result = await http.patch(`/attachment/${att.id}/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
          return result.data;
        } else if (att.file) {
          const result = await http.post(`/attachment/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          });
          return result.data;
        }
      }

      async deleteCategory (slug) {
        const result = await http.delete(`/category/${slug}/`);
        return result.data
    }

   
     async deleteTeacher (slug) {
        const result = await http.delete(`/teacher/${slug}/`);
        return result.data
    }

    async deleteCourse (slug) {
        const result = await http.delete(`/course/${slug}/`);
        return result.data
    }

     async deleteUser (slug) {
        const result = await http.delete(`/userlist/${slug}/`);
        return result.data
    }


    async deleteModule(slug) {
      const result = await http.delete(`/module/${slug}/`);
      return result.data;
    }

    async deleteAttachment(id) {
      const result = await http.delete(`/attachment/${id}/`);
      return result.data;
    }

    async deleteOrganization(slug) {
        const result = await http.delete(`/organization/${slug}/`);
        return result.data;
      }

     async deleteNotification(id) {
        const result = await http.delete(`/notification/${id}/`);
        return result.data
    }


    async login(formData) {
      try {
        const res = await http.post("login/", { ...formData });

        return {
          success: res.status === 200,
          requires_2fa: res.data.requires_2fa,
          user_id: res.data.user_id,
        };
      } catch (err) {
        return {
          success: false,
          requires_2fa: false,
          user_id: null,
        };
      }
    }

    async verifyOtp(data) {
      try {
        const res = await http.post("verify-otp/", {
          user_id: data.user_id,
          code: data.code,
        });

        return {
          success: res.status === 200,
        };
      } catch (err) {
        return {
          success: false,
        };
      }
    }

    async resendOtp(data) {
      try {
        const res = await http.post("resend-otp/", {
          user_id: data.user_id,
        });

        return {
          success: res.status === 200,
          message: res.data.message,
        };
      } catch (err) {
        return {
          success: false,
          message: err.response?.data?.message || "Errore resend OTP",
        };
      }
    }

    async forgotPassword(data) {
      try {
        const res = await http.post("forgot-password/", {
          email: data.email,
        });

        return {
          success: res.status === 200,
          message: res.data.message || "Email inviata",
        };
      } catch (err) {
        return {
          success: false,
          message: err.response?.data?.message || "Errore recupero password",
        };
      }
    }

    async resetPassword(data) {
      const res = await http.post("reset-password/", {
        uid: data.uid,
        token: data.token,
        password: data.password,
        confirmPassword: data.confirmPassword
      });

      return res.data;
    }



    async checkSession() {
      try {
        const res = await http.get("user/");
        return {
          success: res.status === 200 && res.data.authenticated,
          is_admin: res.data.is_admin || false,
        };
      } catch (error) {
        return { success: false, is_admin: false };
      }
    }


    async logout() {
      await http.post("logout/", {});
    }





    async startLesson(id) {
      const result = await http.post(`/lesson/${id}/start/`);
      return result.data;
    }

    async startExam(id) {
      const result = await http.get(`/exam/${id}/start/`);
      return result.data;
    }

    async submitExam(id, payload){
      const result = await http.post(`/exam/${id}/submit/`, payload);
      return result.data;
    }

    async completedLesson(lessonId) {
      const result = await http.post(`/lesson/${lessonId}/complete/`);
      return result.data;
    }

    async sendVideoEvent(lessonId, event, currentTime) {
      const result = await http.post('/lesson-video/event/', { lesson: lessonId, video_event: event, current_time: currentTime });
      return result.data;
    }

    async submitReview(slug, ratingValue,  reviewComment) {
      const result = await http.post('/review/', {course: slug, rating: ratingValue * 2, comment: reviewComment});
      return result.data;      

    }

     async Registation(formData) {
      const result = await http.post('/register/', formData);
      return result.data;
    }

    async requestRegistration(formData) {
      const result = await http.post('/registration-request/', formData);
      return result.data;
    }

    async confirmRegistration(data) {

      const response = await http.post("/confirm-registration/", data);

      return response.data;
    }

    async selectedCourses(category) {
      let url = '/course/';
      if (category) url += `?category=${encodeURIComponent(category)}`;
      const result = await http.get(url);
      return result.data;
}
    async getCertificate(id) {
      const result = await http.get(`/certificates/${id}`);
      return result.data; 
}
    async getAdminCertificate(userSlug, orgSlug = null) {
      const result = await http.get("/certificates/", {
        params: {
          slug: userSlug,
          ...(orgSlug ? { org_slug: orgSlug } : {})
        }
      });

      return result.data;
    }

     async getCertificates() {
      const result = await http.get(`/certificates/`);
      return result.data; 
}

    async getUserCertificates(slug) {
      const res = await http.get(`/userlist/${slug}/user_certificates/`);
      return res.data;
  }

    async getUserProgress(slug) {
      const res = await http.get(`/userlist/${slug}/user_progress/`);
      return res.data;
  }
   
    async getUserCourseProgressDetail(userSlug, courseSlug) {
      const res = await http.get(`/userlist/${userSlug}/user_course_progress_detail/?course=${courseSlug}`);
      return res.data;
  }

  async getLegal() {
      const result = await http.get(`/edit/1`);
      return result.data; 
}

  async updateLegal (form) {
          const formData = new FormData();
          formData.append('privacy_policy', form.privacy_policy);
          formData.append('legal_notes', form.legal_notes);
          formData.append('cookie_policy', form.cookie_policy);
          
          const result = await http.patch(`/edit/1/`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
          return result.data
      }

  async joinOrganization (data) {
        const result = await http.post('/organizations/join/', data, {
        headers: { 'Content-Type': 'application/json' },
      });
        return result.data
    }

   async getMyOrgCourses() {
      const result = await http.get(`/organization-course/`);
      return result.data; 
   }

  async exportUsersPdf(data) {
    const result = await http.post('/userlist/export-users-pdf/', data, {
      headers: { 'Content-Type': 'application/json' },
      responseType: 'blob',
    });

    return result.data;
  }

  async getCaptcha() {
      let result = await http.get('captcha-generator/');
      return result.data;
  }

   

}

export default new ApiService();